import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../contexts/store"

import Link from "../../Elements/Link"
import Thumbnail from "../../Elements/Thumbnail"
import TimeFromNow from "../../Elements/TimeFromNow"
import { Avatar, AvatarGroup, Box, Divider, Paper } from "@mui/material"
import UxIcon from "../../Elements/UxIcon"


const MaterialPreview = ({podId}: {podId: string}) => {
  const { t } = useTranslation()
  const { podStore } = useStore()
  const nofPreviews = 4
  const seenNodes = podStore.getLastViewedNodesFromPod().slice(0,nofPreviews)
  const totalNodes = podStore.getNodeIds()
  const thumbnailbHeight = 150
  const nofUnseenFiles = Math.max(0, totalNodes.length - seenNodes.length)

  const unseenFiles = nofUnseenFiles ? <Link to={'/pod/' + podId + '/contents'} noDecoration>
    <Box sx={{margin: "30px",textAlign:'center'}}>
      <Divider />
      {seenNodes.length ? '+' : ''} {t('nofUnseenFiles', {count: nofUnseenFiles})}
      {seenNodes.length < 3 ? <Box sx={{textAlign:'center'}}>
        <Box sx={{width:'auto', display:'inline-block'}}>
          <AvatarGroup sx={{display:'flex', width:'auto'}} total={nofUnseenFiles}>
            {totalNodes.map((n, i) => <Avatar key={i}><UxIcon id={"podFile"} fontSize="small" /></Avatar>)}
          </AvatarGroup>
        </Box>
      </Box> : null}
    </Box>
  </Link> : null

  return (
    <>
    <Box sx={{
      display: "grid",
      gridTemplateColumns: "50% 50%",
      gap: "15px",
      margin: "30px",
    }}>
      {seenNodes.map(node => (
        <Link key={node.nodeId} to={`/pod/${podId}/pdf/${node.nodeId}/`} noDecoration={true}>
          <Paper sx={{
            overflow: "hidden",
            padding: "5px",
            ":hover": {
              backgroundColor: "whitesmoke",
              cursor: "pointer"
            }
          }}>
            <Box sx={{
              fontSize: "12px",
              fontWeight: 400,
              padding: "5px 10px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}>
              {podStore.getFilename(node.nodeId)}
            </Box>
            <Box sx={{display: "grid", justifyItems: "center"}}>
              <Thumbnail key={node.nodeId} height={thumbnailbHeight} nodeId={node.nodeId} pageNumber={1} />
            </Box>
            <Box sx={{color: "grey", fontSize: "11px", justifySelf: "end", paddingRight: "5px"}}>
              <TimeFromNow timestamp={node.tSeen*1000} />
            </Box>
          </Paper>
        </Link>
      ))}
    </Box>
    {unseenFiles}
    </>
  )
}

export default observer(MaterialPreview)
